import { create } from 'zustand'
import { isPwaInstalled } from '@/modules/pwa/services/webpushClient'

export type BeforeInstallPromptEvent = Event & {
  prompt: () => Promise<void>
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed'; platform: string }>
}

type Store = {
  deferred: BeforeInstallPromptEvent | null
  canInstall: boolean
  installing: boolean
  installed: boolean
  isIosSafari: boolean
  setDeferred: (e: BeforeInstallPromptEvent | null) => void
  setInstalling: (v: boolean) => void
  setInstalled: (v: boolean) => void
  setIsIosSafari: (v: boolean) => void
}

export const usePwaInstallStore = create<Store>((set) => ({
  deferred: null,
  canInstall: false,
  installing: false,
  installed: typeof window !== 'undefined' ? isPwaInstalled() : false,
  isIosSafari: false,
  setDeferred: (e) => set({ deferred: e, canInstall: !!e }),
  setInstalling: (v) => set({ installing: v }),
  setInstalled: (v) => set({ installed: v }),
  setIsIosSafari: (v) => set({ isIosSafari: v }),
}))

